import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"add\">\n<g>\n\t<path d=\"M12,0C5.373,0,0,5.373,0,12s5.373,12,12,12s12-5.373,12-12S18.627,0,12,0z M12,22\n\t\tC6.477,22,2,17.521,2,12C2,6.477,6.477,2,12,2s10,4.478,10,10C22,17.521,17.523,22,12,22z\" />\n\t<polygon points=\"13,6 11,6 11,10.999 6,10.999 6,12.999 11,12.999 11,17.999 13,17.999 13,12.999 18,12.999\n\t\t18,10.999 13,10.999 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol